import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';

import { AppConstants } from '../../../app.constants';

@Component({
  selector: 'pagination',
  standalone: true,
  imports: [
    MatPaginatorModule
  ],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent {
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() totalItems: number;
  @Input() pageSizeOptions = AppConstants.PAGE_SIZE_OPTIONS;
  @Output() pageChanged: EventEmitter<PageEvent> = new EventEmitter();

  changePage(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageChanged.emit(event);
  }
}
